import {FjdIcon, FjdStack} from "@efast/fjd-react-components";
import {Certificate} from "../../model/Certificate";
import "./CertificateUser.css";

export interface CertificateUserProps {
    certificate?: Certificate;
}

function CertificateUser({certificate}: CertificateUserProps) {
    if (!certificate || !certificate.user) {
        return null;
    }
    return (
        <FjdStack orientation="horizontal" spacing="none"
                  className="certificate-user">
            <FjdIcon glyph="user-avatar" size="xxl"></FjdIcon>
            <FjdStack>
                <strong>{certificate.user.firstName} {certificate.user.lastName}</strong>
            </FjdStack>
        </FjdStack>
    );
}

export default CertificateUser;
